import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions, selectors as operationSelectors } from 'ducks/uiOperations';
import { actions as formActions, selectors as formSelectors } from 'ducks/form';
import CustomerQuoteEnquiry from './CustomerQuoteEnquiry';
import { reset, destroy } from 'redux-form';
import { selectors as diarySelectors } from 'ducks/common/diary';
import { selectors as quoteSelectors, actions as quoteActions } from 'ducks/customerQuoteEnquiry/quote';
import { actions as BOMActions, selectors as BOMSelectors } from 'ducks/customerQuoteEnquiry/BOM';
import { selectors as reservationLotSelectors } from 'ducks/customerQuoteEnquiry/reservationLots';
import { selectors as bomReservationLotSelectors } from 'ducks/customerQuoteEnquiry/bomReservationLots';
import { selectors as reservationSerialsSelectors } from 'ducks/customerQuoteEnquiry/reservationSerials';
import { selectors as bomReservationSerialsSelectors } from 'ducks/customerQuoteEnquiry/bomReservationSerials';
import { selectors as customerSelectors, actions as customerActions } from 'ducks/customer';
import { selectors as staffSelectors } from 'ducks/staff';

const FORM_NAME = 'CustomerQuoteEnquiry';

const mapStateToProps = (state) => ({
  operationMode: operationSelectors.operationMode(state),
  selectedTab: uiSelectors.selectedTab(state),
  selectedQuote: quoteSelectors.selected(state),
  selectedDiary: diarySelectors.selected(state),
  selectedQuoteLine: quoteSelectors.selectedQuoteLine(state),
  selectedQuoteSchema: quoteSelectors.selectedQuoteSchema(state),
  selectedBOMLine: BOMSelectors.selected(state),
  quoteLinesData: quoteSelectors.quoteLinesData(state),
  quoteDetails: quoteSelectors.quoteDetails(state),
  quoteDetailsSchema: quoteSelectors.quoteDetailsSchema(state),
  quoteSummary: quoteSelectors.quoteSummary(state),
  quoteSummarySchema: quoteSelectors.quoteSummarySchema(state),
  quoteLineDetail: quoteSelectors.quoteLineDetail(state),
  quoteLineDetailSchema: quoteSelectors.quoteLineDetailSchema(state),
  quoteLineSummary: quoteSelectors.quoteLineSummary(state),
  reservationDetails: quoteSelectors.reservationDetails(state),
  reservationDetailsSchema: quoteSelectors.reservationDetailsSchema(state),
  isBrowseLookUpOpen: uiSelectors.isBrowseLookUpOpen(state),
  isMenuOptionOpen: uiSelectors.isMenuOptionOpen(state),
  selectedForm: formSelectors.selected(state),
  bomLines: BOMSelectors.lines(state),
  bomLineDetails: BOMSelectors.lineDetails(state),
  bomLineDetailSummary: BOMSelectors.lineDetailSummary(state),
  bomReservationDetails: BOMSelectors.reservationDetails(state),
  reservationLotLines: reservationLotSelectors.lines(state),
  bomReservationLotLines: bomReservationLotSelectors.lines(state),
  reservationSerialLines: reservationSerialsSelectors.lines(state),
  bomReservationSerialLines: bomReservationSerialsSelectors.lines(state),
  selectedCustomer: customerSelectors.selected(state),
  isMainMenuOpen: uiSelectors.isMainMenuOpen(state),
  staff: staffSelectors.staff(state),
  quoteSummaryPanel: quoteSelectors.quoteSummaryPanel(state),
  selectedQuoteLoading: quoteSelectors.isLoading(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    toggleCustomerLookUp: uiActions.toggleCustomerLookUp,
    toggleBrowseLookUp: uiActions.toggleBrowseLookUp,
    changeOperationMode: operationActions.changeOperationMode,
    changeSelectedTab: uiActions.changeSelectedTab,
    getFormSchema: formActions.search,
    changeSelectedForm: formActions.setSelected,
    toggleMenuOption: uiActions.toggleMenuOption,
    fetchQuoteDetails: quoteActions.fetchCustomerQuoteDetails,
    fetchQuoteSummary: quoteActions.fetchQuoteSummary,
    fetchQuoteLines: quoteActions.fetchQuoteLines,
    fetchQuoteLineDetail: quoteActions.fetchQuoteLineDetail,
    fetchQuoteLineSummary: quoteActions.fetchQuoteLineSummary,
    fetchReservationDetails: quoteActions.fetchReservationDetails,
    fetchQuoteSummaryPanel: quoteActions.fetchQuoteSummaryPanel,
    fetchBOMLineDetails: BOMActions.fetchLineDetails,
    fetchBOMLineDetailSummary: BOMActions.fetchLineDetailSummary,
    fetchBOMReservationDetails: BOMActions.fetchReservationDetails,
    resetForm: () => reset(FORM_NAME),
    changeConfirmationDialog: uiActions.changeConfirmationDialog,
    changeSelectedCustomer: customerActions.setSelected,
    closeMenu: uiActions.closeMainMenu,
    resetSearchLookupDrawer: quoteActions.reset,
    destoryForm: () => destroy('CustomerQuoteEnquiry'),
    setLookupData: quoteActions.setLookupListData,
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CustomerQuoteEnquiry);
